import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import style from "../common.module.scss";
import CustomButton from "../../../custom/custom-button/CustomButton";

const OrderAccessRestricted = ({ onClose, isModal = true, assignmentMethod = "Tender" }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const showClosedTitle = assignmentMethod === "Auction" || assignmentMethod === "Tender";

  const handleBack = () => {
    if (isModal && onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={style.orders_content} style={{ textAlign: "center", padding: "40px 20px" }}>
      {showClosedTitle && (
        <h3 style={{ marginBottom: "16px", fontSize: "18px", fontWeight: "600" }}>
          {t(assignmentMethod === "Auction" ? "orderInfo.auctionClosed" : "orderInfo.tenderClosed")}
        </h3>
      )}
      <p style={{ marginBottom: "24px", color: "#666" }}>{t("orderInfo.orderNotAvailable")}</p>
      <CustomButton isFall text={t("orderBooking.button.back")} onClick={handleBack} isDark />
    </div>
  );
};

export default OrderAccessRestricted;
